import i18n from "@/common/i18n";
import Layout from '@/layout/index';

const router = [
  {
    path: '/other',
    component: Layout,
    redirect: '/other/msgList',
    meta: { auth: true, title: i18n.t('lang.k_018001'), name: 'other', icon: 'vh-icon-s-help' },
    hidden: true,
    children: [
      {
        path: 'msgList',
        component: () => import('@/views/PlatformModule/Message/list'),
        meta: { auth: true, title: i18n.t('lang.k_018002'), name: 'msgList', icon: 'table' }
      },
      {
        path: 'msgDetail/:str(\\d+)',
        component: () => import('@/views/PlatformModule/Message/detail'),
        meta: {
          auth: true,
          title: i18n.t('lang.k_018003'),
          name: 'msgDetail',
          icon: 'table',
          activeMenu: '/other/msgList'
        },
        hidden: true
      },
      {
        path: 'downloadList',
        component: () => import('@/views/PlatformModule/download'),
        meta: { auth: true, title: i18n.t('lang.k_018004'), name: 'downloadList', icon: 'table' }
      },
      {
        path: 'trash',
        component: () => import('@/views/PlatformModule/trash'),
        meta: { auth: true, title: i18n.t('lang.k_018005'), name: 'trash', icon: 'table' }
      },
      {
        path: 'feedbackList',
        component: () => import('@/views/PlatformModule/feedbackList'),
        meta: { auth: true, title: i18n.t('lang.k_018006'), name: 'feedbackList', icon: 'table' }
      }
    ]
  }
];
export default router;
